import { render } from "./BorderSection.vue?vue&type=template&id=043b4188&scoped=true&ts=true"
import script from "./BorderSection.vue?vue&type=script&lang=ts"
export * from "./BorderSection.vue?vue&type=script&lang=ts"

import "./BorderSection.vue?vue&type=style&index=0&id=043b4188&scoped=true&lang=css"

import exportComponent from "/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043b4188"]])

export default __exports__